// app/javascript/controllers/mover_estimate_insurance_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.populateDropdown()
  }

  populateDropdown() {
    const dropdown = this.selectTarget
    const insuranceRatesData = this.element.dataset.insuranceRates


    if (insuranceRatesData) {
      try {
        const insuranceRates = JSON.parse(insuranceRatesData)
        insuranceRates.forEach((rate, index) => {
          const option = document.createElement("option")
          option.value = JSON.stringify(rate)
          option.textContent = `${rate.name} - $${rate.rate} per 1k ${rate.unit} (Deductible: $${rate.deductible})`
          dropdown.appendChild(option)
        })
      } catch (error) {
        console.error("Error parsing insurance rates data:", error)
      }
    }
  }

  updateFields(event) {
    const selectedRate = JSON.parse(event.target.value)

    if (selectedRate) {
      document.getElementById("name").value = selectedRate.name
      document.getElementById("deductible").value = selectedRate.deductible
      document.getElementById("rate_per_1000_lbs").value = selectedRate.rate
      document.getElementById("unit").value = selectedRate.unit
    } else {
      document.getElementById("name").value = ""
      document.getElementById("deductible").value = ""
      document.getElementById("rate_per_1000_lbs").value = ""
      document.getElementById("unit").value = ""
    }
  }
}